import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

@Injectable()
export class NeoRolService {
  public url: String;

  constructor(private _http: HttpClient) {

    this.url = environment.apiLocalUrl + 'roles';
  }


  crearRol(neoRol): Observable<any> {
    let body = JSON.stringify(neoRol);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/crear', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  crearRolFuncionalidad(neoRol): Observable<any> {
    let body = JSON.stringify(neoRol);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/crear/rolesFuncionalidades', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getRolesIF(): Observable<any> {
    return this._http.get(this.url + '/entidad/2').pipe(catchError(HandleHttpError));

  }

  getRolesActivos(): Observable<any> {
    return this._http.get(this.url + '/rolesActivos').pipe(catchError(HandleHttpError));
  };

  getRolesPorNombre(nombreRol): Observable<any> {
    return this._http.get(this.url + '/findNeoRolByNombre/' + nombreRol).pipe(catchError(HandleHttpError));
  };

  getRolesPorTipoEntidad(idEntidad): Observable<any> {
    return this._http.get(this.url + '/entidad/' + idEntidad).pipe(catchError(HandleHttpError));
  };

  getRolesPorTipoEntidadYNombreRol(idEntidad, nombreRol): Observable<any> {
    return this._http.get(this.url + '/findNeoRolByNeoTipoEntidadAndNombreRol/' + idEntidad + '/' + nombreRol).pipe(catchError(HandleHttpError));
  };

  getRoles(): Observable<any> {
    return this._http.get(this.url + '/').pipe(catchError(HandleHttpError));
  };

  getRolFindById(idRol): Observable<any> {
    return this._http.get(this.url + '/' + idRol).pipe(catchError(HandleHttpError));
  };

  getRolesBancoldex(): Observable<any> {
    return this._http.get(this.url + "/entidad/1").pipe(catchError(HandleHttpError));
  }
}